import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const INFO_UNICODE_ICON = '\u{24D8}';

export default function HelpMessage({help, predicate}) {
  if (!help) {
    return null;
  }
  
  const renderTooltip = (
    <Tooltip id={predicate}>
      {help}
    </Tooltip>
  );

  return (
    <div className="info-hover">
      <OverlayTrigger overlay={renderTooltip} >
        <div><i style={{color : '#db9943'}} className="fa fa-question-circle"></i></div>
      </OverlayTrigger>
    </div>
  );
}